export class Log {
    static warn(message?: unknown, ...optionalParams: unknown[]): void {
        // eslint-disable-next-line no-console
        console.warn(message, ...optionalParams);
    }
}
